import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { WarningIconComponent } from '@kuiper/icons';
import { RichEditorDualLangTextAreaComponent } from '../../../../../../ui-components/lib/rich-editor-dual-lang-text-area/rich-editor-dual-lang-text-area.component';
import { ValidationMessageComponent } from '../../../../../../ui-components/lib/validation-message/validation-message.component';
import { PaginatedSelectComponent } from '../../../../../../ui-components/lib/paginated-select/paginated-select.component';
import { baseUrl } from '../../../../../common/constants/endpoints.constants';

@Component({
  selector: 'lib-reject-modal',
  imports: [
    ReactiveFormsModule,
    TranslocoPipe,
    PaginatedSelectComponent,
    RichEditorDualLangTextAreaComponent,
    ValidationMessageComponent,
    WarningIconComponent,
  ],
  templateUrl: './reject-modal.component.html',
  styleUrl: './reject-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RejectModalComponent {
  translocoService = inject(TranslocoService);
  fb = inject(FormBuilder);
  stepId = input.required<string | number>();
  closeModal = output<void>();
  submitReject = output<any>();
  rejectForm = signal<FormGroup>(
    this.fb.group({
      reason_option_id: ['', Validators.required],
      comment: ['', [Validators.required]],
    })
  );
  baseUrl = baseUrl;

  onSubmit(): void {
    if (this.rejectForm().valid) {
      const formValue = this.rejectForm().getRawValue();
      this.submitReject.emit(formValue);
    } else {
      this.rejectForm().markAsDirty();
      this.rejectForm().markAllAsTouched();
    }
  }

  onClose(): void {
    this.closeModal.emit();
  }
}
